module.exports = __webpack_public_path__ + "static/media/Anna.35452b28.jpg";